<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <v-text-field
            v-model="profesional.nombres"
            :rules="obligatorioAlfabetico"
            label="Nombre/s"
            required
            variant="solo"
        ></v-text-field>
        <v-text-field
            v-model="profesional.apellidos"
            :rules="obligatorioAlfabetico"
            label="Apellido/s"
            required
            variant="solo"
        ></v-text-field>
        <v-text-field
            v-model="profesional.matriculaProvincial"
            :rules="opcionalNumerico"
            label="Matrícula provincial"
            variant="solo"
        ></v-text-field>
        <v-text-field
            v-model="profesional.matriculaNacional"
            :rules="opcionalNumerico"
            label="Matrícula nacional"
            variant="solo"
        ></v-text-field>
        <v-text-field
            v-model="profesional.cuit"
            :rules="obligatorioNumerico"
            label="Cuit"
            required
            variant="solo"
        ></v-text-field>
        <div v-if="!this.edicion">
            <FacturadoresTotSelect
                @facturador-seleccionado="facturadorId = $event">
            </FacturadoresTotSelect>
            <EspecialidadesTotSelect
                @especialidades-seleccionadas="profesional.especialidades = $event">
            </EspecialidadesTotSelect>
            <v-switch
                v-model="profesional.trabajaConIoma"
                label="Profesional trabaja con IOMA"
                :color="profesional.trabajaConIoma ? 'rgb(34, 121, 37)' : 'grey'"
                :track-color="profesional.trabajaConIoma ? 'green' : 'grey'"
                hide-details
                inset
                dense
                ripple
            />
        </div>
        <v-btn
            type="submit"
            :disabled="!valid"
            id="boton-verde"
            :loading="cargando"
        >
            {{this.edicion ? 'Editar profesional' : 'Agregar profesional'}}
        </v-btn>
    </v-form>
    <ClosableAlert
        v-if="alert"
        :type="alertType"
        :key="alertKey"
        :texto="mensaje"
        :titulo="this.edicion ? 'Editar profesional' : 'Agregar profesional'"
    ></ClosableAlert>
</template>
<style src="../assets/general.css"></style>
<script>
/* eslint-disable */
import { obligatorioAlfabetico, obligatorioNumerico, obligatorio, opcionalNumerico } from '@/_helpers/rules';
import AdminService from '@/api/AdminService';
import ClosableAlert from './ClosableAlert.vue';
import FacturadoresTotSelect from './FacturadoresTotSelect.vue';
import EspecialidadesTotSelect from './EspecialidadesTotSelect.vue';
import ProfesionalService from '@/api/ProfesionalService';
import Profesional from '@/interfaces/adminInterfaces'

const adminService = new AdminService();
const profesionalService = new ProfesionalService();

export default {
    components: {
        ClosableAlert,
        FacturadoresTotSelect,
        EspecialidadesTotSelect
    },
    props: {
        edicion: {
            type: Boolean,
            default: false
        },
        profesionalExistente: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            valid: false,
            profesional: Profesional = {
                matriculaNacional: null,
                matriculaProvincial: null,
                trabajaConIoma: true,
            },
            facturadorId: null,
            obligatorioAlfabetico: obligatorioAlfabetico,
            opcionalNumerico: opcionalNumerico,
            obligatorioNumerico: obligatorioNumerico,
            obligatorio: obligatorio,
            cargando: false,
            //datos para el alert
            alert: false,
            alertType: 'error',
            mensaje: '',
            alertKey: 0
        }
    },
    mounted() {
        if(this.edicion) {
            this.profesional = this.profesionalExistente;
        }
    },
    methods: {
        async handleSubmit() {
            if(!(this.profesional.matriculaNacional || this.profesional.matriculaProvincial)) {
                this.alertType = 'error';
                this.mensaje = 'Debe ingresar al menos una matrícula';
                this.alert = true;
                this.alertKey += 1;
                return;
            }
            if(this.profesional.matriculaProvincial == ""){
                this.profesional.matriculaProvincial = null;
            }
            if(this.profesional.matriculaNacional == ""){
                this.profesional.matriculaNacional = null;
            }
            this.cargando = true;
            let response;
            if(this.edicion) {
                response = await profesionalService.editarProfesional(this.profesional);
            } else {
                response = await adminService.crearProfesional(this.profesional, this.facturadorId);
            }
            if(response && response.status === 200) {
                this.alertType = 'success';
                this.mensaje = this.edicion ? 'Profesional editado con éxito' : 'Profesional creado con éxito';
            } else {
                this.alertType = 'info';
                this.mensaje = response.data ? response.data : 'Ha ocurrido un error inesperado';
            }
            this.alert = true;
            this.alertKey += 1;
            this.cargando = false;
        },
    },
}
</script>